<script lang="ts">
  import { onMount } from "svelte";
  import Button from "../../components/Button.svelte";
  import Icon from "../../components/Icon.svelte";
  import MainLayout from "../../layout/MainLayout.svelte";
  import CreateActivityModal from "./CreateActivityModal.svelte";
  import { createActivityModalOpen, createNewTimer, load, timers } from "./timer.store";
  import UserTimer from "./UserTimer.svelte";

  onMount(() => load());
</script>

<CreateActivityModal open={$createActivityModalOpen} />

<MainLayout>
  <div class="timers-filters">
    <div class="columns">
      <div class="column">
        <Button on:click={createNewTimer}>
          <Icon name="add" />
          <span>Nuovo Timer</span>
        </Button>
      </div>
    </div>

    {#each $timers as timer}
      <UserTimer timerId={timer.timerId} />
    {/each}
  </div>
</MainLayout>

<style>
  .timers-filters {
    margin-bottom: 0.5rem;
  }
</style>
